import React from "react";
import { Form } from "semantic-ui-react";
import NumberInput from "semantic-ui-react-numberinput";
import useLogin from "@common/components/hooks/useLogin";

/**
 * The semantic-ui-react-numberinput component expects a string value rather than
 * a number because it follows the standard HTML input behavior where form values
 * are always handled as strings, even for numeric inputs. This is a deliberate
 * design choice that aligns with both React's controlled component pattern and HTML standards.
 */
export default function NumberInputComponent({
  value,
  name = "",
  onChange = (value) => {},
  label = "",
  labelClass = "w-30",
  fieldStyle = "flex-between flex-row-center",
  inputContainerStyle = "",
}) {
  // Convert value to string to ensure compatibility
  const stringValue =
    value !== null && value !== undefined ? String(value) : "0";

  const handleChange = (formValue) => {
    // Convert to number before passing to parent
    const numericValue =
      formValue === "" || formValue === null ? 0 : Number(formValue);
    onChange(numericValue);
  };

  const [{ isInReadMode }] = useLogin();

  return (
    <Form.Field className={fieldStyle}>
      {label && <label className={labelClass}>{label}</label>}
      <div className={inputContainerStyle}>
        <NumberInput
          name={name}
          value={stringValue}
          onChange={handleChange}
          disabled={isInReadMode}
        />
      </div>
    </Form.Field>
  );
}
